import { render, staticRenderFns } from "./Step1.vue?vue&type=template&id=53d387c5&scoped=true"
import script from "./Step1.vue?vue&type=script&lang=js"
export * from "./Step1.vue?vue&type=script&lang=js"
import style0 from "./Step1.vue?vue&type=style&index=0&id=53d387c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d387c5",
  null
  
)

export default component.exports